import React from "react";

import { DeviceStatus } from "gql/generated/types";
import { Tag } from "primereact/tag";
import { useTimezone } from "hooks/useTimezone";
import { T } from "services/lang/LanguageService";
import { fmtDatetime } from "utils/time-utils";

const DeviceStatusTag: React.FC<{ status?: DeviceStatus; lastMeasurementDate?: string }> = ({
  status,
  lastMeasurementDate,
}) => {
  const tz = useTimezone();
  const formatLastMeasurementDate = lastMeasurementDate && fmtDatetime(lastMeasurementDate, tz.display);
  const lastMeasDateString = `${T("mdm.last-measurement")}: ${formatLastMeasurementDate}`;
  switch (status) {
    case "OFFLINE":
      return <Tag value="Offline" severity="danger" title={lastMeasDateString} />;
    case "ONLINE":
      return <Tag value="Online" severity="success" title={lastMeasDateString} />;
    default:
      return <Tag value="N/A" className="bg-gray-500" />;
  }
};

export default DeviceStatusTag;
